import { render, staticRenderFns } from "./spareGetDetail.vue?vue&type=template&id=76d295ec&scoped=true"
import script from "./spareGetDetail.vue?vue&type=script&lang=js"
export * from "./spareGetDetail.vue?vue&type=script&lang=js"
import style0 from "./spareGetDetail.vue?vue&type=style&index=0&id=76d295ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d295ec",
  null
  
)

export default component.exports